import './index.scss'
import text from './text.json'
import {PageTitle} from '../../components/core/title'
import ResponsivePageTitle from '../../components/core/title/ResponsivePageTitle'
import Footer from '../../components/layouts/footer'
import {getTokenAndWorkflowId} from '../../stores/automation'
import {useNavigate, useParams} from 'react-router-dom'
import {useEffect} from 'react'
import {useDispatch, useSelector} from 'react-redux'
import Designer from './Designer'
import Breadcrumb from '../../components/core/breadcrumb'
import {routes} from '../../routes'
import classNames from 'classnames'

const AutomationDesigner = () => {
    const navigate = useNavigate()
    const {id} = useParams()
    const dispatch = useDispatch()
    const token = useSelector(state => state.automation.token)
    const workflowId = useSelector(state => state.automation.workflowId)
    const isDarkMode = useSelector(state => state.sidebar.isDarkMode)

    useEffect(() => {
        dispatch(getTokenAndWorkflowId(id, navigate))
    }, [id])

    return (
        <main className={classNames('main automation-designer', {
            dark: isDarkMode
        })}>
            <div>
                <div>
                    <ResponsivePageTitle/>
                    <div className="content-title">
                        <div className="left-side">
                            <div>
                                <Breadcrumb data={[text.section, routes.automations]}/>
                                <PageTitle>
                                    <h1  className={classNames('page-title', {
                                        dark: isDarkMode
                                    })}>{text.title}</h1>
                                </PageTitle>
                            </div>
                        </div>
                    </div>
                </div>
                <div className={classNames('content-body', {
                    dark: isDarkMode
                })} id="designer-iframe">
                    {token && workflowId && <Designer token={token} workflowId={workflowId}/>}
                </div>
            </div>
            <Footer/>
        </main>
    )
}

export default AutomationDesigner
